// The shelf of the synchronization loader (EcosShelfProgress.vue, #23635): the marketing "rayon simple" visual, the
// same shelf as the login page. 2 cartons, 3 cans, 4 yogurt facings stacked by 2, 2 bricks and 2 bottles: 10 slots,
// one product placed every 10 %. Coordinates are the visual's px: products stand on y = 120, the board is at y = 122.
// Every product is a list of [svg path, fill] shapes, drawn in order.

/** Rectangle path with different top and bottom corner radii. */
export const rr = (x, y, w, h, rxT = 0, ryT = rxT, rxB = rxT, ryB = rxB) => `M${x} ${y + ryT}` + (ryT ? `A${rxT} ${ryT} 0 0 1 ${x + rxT} ${y}` : '') + `H${x + w - rxT}` + (ryT ? `A${rxT} ${ryT} 0 0 1 ${x + w} ${y + ryT}` : '') + `V${y + h - ryB}` + (ryB ? `A${rxB} ${ryB} 0 0 1 ${x + w - rxB} ${y + h}` : '') + `H${x + rxB}` + (ryB ? `A${rxB} ${ryB} 0 0 1 ${x} ${y + h - ryB}` : '') + 'Z';

/** Ellipse path centred on (cx, cy). */
export const ell = (cx, cy, rx, ry = rx) => `M${cx - rx} ${cy}a${rx} ${ry} 0 1 0 ${2 * rx} 0a${rx} ${ry} 0 1 0 ${-2 * rx} 0Z`;

// A yogurt pot whose lid is at y = L (56 high, lid included)
const yogurtPot = (x, L) => [
	[rr(x - 1, L, 38, 6, 2), '#6F8FD6'],
	[`M${x} ${L + 5}H${x + 36}L${x + 33} ${L + 52}Q${x + 32.5} ${L + 56} ${x + 29} ${L + 56}H${x + 7}Q${x + 3.5} ${L + 56} ${x + 3} ${L + 52}Z`, '#C9D4EE'],
	[`M${x + 1.2} ${L + 20}H${x + 34.8}L${x + 33.4} ${L + 42}H${x + 2.6}Z`, '#3F63B5'],
	[`M${x + 1.7} ${L + 28}H${x + 34.3}L${x + 34} ${L + 33}H${x + 2}Z`, '#96A9D6'],
];

const PRODUCTS = {
	carton: (x) => [
		[rr(x, 8, 106, 112, 4), '#C9D4EE'],
		[rr(x, 42, 106, 35), '#A3AFCE'],
	],
	can: (x) => [
		[rr(x + 2, 64, 46, 4, 2, 2, 0, 0), '#DCE5F7'],
		[rr(x, 68, 50, 52, 5), '#E04A3C'],
		[rr(x, 81, 50, 26), '#EE9C94'],
	],
	yogurts: (x) => [64, 8].flatMap((L) => [0, 38].flatMap((d) => yogurtPot(x + d, L))),
	brick: (x) => [
		[`M${x + 2} 38L${x + 35} 24L${x + 68} 38Z`, '#7E8FB6'],
		[rr(x, 40, 70, 80, 3), '#8FA3CF'],
		[rr(x, 78, 70, 20), '#C2CCE5'],
	],
	bottle: (x) => [
		[rr(x + 19, 0, 20, 8, 5, 5, 1, 1), '#DCE5F7'],
		[rr(x + 22, 8, 14, 30), '#6F8FD6'],
		[rr(x, 34, 58, 86, 29, 18, 10, 8), '#6F8FD6'],
		[rr(x, 75, 58, 21), '#B0C2E8'],
	],
};

/**
 * The neutral shelf, slots 0 to 9 from left to right:
 * 0, 1 cartons · 2, 3, 4 cans · 5 yogurts · 6, 7 bricks · 8, 9 bottles
 */
export const SHELF = {
	viewBox: '0 -4 760 134',
	board: { x: 4, y: 122, w: 752, h: 6 },
	items: [PRODUCTS.carton(8), PRODUCTS.carton(121), PRODUCTS.can(234), PRODUCTS.can(290), PRODUCTS.can(346), PRODUCTS.yogurts(402), PRODUCTS.brick(478), PRODUCTS.brick(555), PRODUCTS.bottle(632), PRODUCTS.bottle(696)],
};
